import { render, staticRenderFns } from "./velocimetroVector.vue?vue&type=template&id=4dfec2cc&scoped=true&"
import script from "./velocimetroVector.vue?vue&type=script&lang=js&"
export * from "./velocimetroVector.vue?vue&type=script&lang=js&"
import style0 from "./velocimetroVector.vue?vue&type=style&index=0&id=4dfec2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfec2cc",
  null
  
)

export default component.exports